import { FC } from "react";
import Sort from "../../UI/Icons/Sort";
import SortAscending from "../../UI/Icons/SortAscending";
import { useLocation } from "react-router";
import { CandidatesSortField, SortOrder } from "../../../store/centers/types";

interface ListHeaderProps {
  type: "preferred" | "approved" | "blocked";
  /** Assuming it's a string like "first_name" */
  selectedSortBy: string;
  /** If sort order is always "asc" or "desc" */
  selectedSortOrder: SortOrder;
  /** Function type with a string parameter */
  handleSortChange: (sortBy: CandidatesSortField, list: string) => void;
}

const ListHeader: FC<ListHeaderProps> = ({
  type,
  selectedSortBy,
  selectedSortOrder,
  handleSortChange,
}) => {
  const location = useLocation();

  return (
    <>
      <div className="border-bottom border-off-white py-10px px-15px d-none d-lg-flex gap-20 align-items-center">
        <div className="flex-grow-1">
          <div className="d-flex gap-20 align-items-center">
            <div className="w-50px"></div>
            <div className="d-flex gap-5 align-items-center">
              <div className="fs-13 fw-700 text-black">Candidate Name</div>
              <div onClick={() => handleSortChange("first_name", type)}>
                <Sort
                  active={selectedSortBy === "first_name"}
                  direction={selectedSortOrder}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="min-w-212px d-flex gap-5 align-items-center">
          <div className="fs-13 fw-700">Rating</div>
          <div onClick={() => handleSortChange("rating", type)}>
            <Sort
              active={selectedSortBy === "rating"}
              direction={selectedSortOrder}
            />
          </div>
        </div>
        {location.pathname.includes("blocked") ? (
          <>
            <div className="min-w-120px d-flex gap-5 align-items-center">
              <div className="fs-13 fw-700">Blocked By</div>
              <SortAscending />
            </div>
            <div className="min-w-120px d-flex gap-5 align-items-center">
              <div className="fs-13 fw-700">Date Blocked</div>
              <SortAscending />
            </div>
          </>
        ) : (
          <>
            <div className="min-w-120px d-flex gap-5 align-items-center">
              <div className="fs-13 fw-700">Any Centre</div>
              <div onClick={() => handleSortChange("any_centre", type)}>
                <Sort
                  active={selectedSortBy === "any_centre"}
                  direction={selectedSortOrder}
                />
              </div>
            </div>
            <div className="min-w-120px d-flex gap-5 align-items-center">
              <div className="fs-13 fw-700">Your Centre</div>
              <div onClick={() => handleSortChange("your_centre", type)}>
                <Sort
                  active={selectedSortBy === "your_centre"}
                  direction={selectedSortOrder}
                />
              </div>
            </div>
          </>
        )}
        <div className="min-w-310px"></div>
      </div>
    </>
  );
};

export default ListHeader;
